{{#if subscription_text}}
  <p class="privacy-text">
    By submitting this form, you are subscribing to Starry Internet.
    After the promotional period you will be billed monthly on the same day.
    We will remind you of the billing terms 7 days before your first bill.
    You can cancel anytime by emailing <a href="mailto:support@starry.com">support@starry.com</a>.
  </p>
{{else if pii_signup}}
  <p class="privacy-text">
    By clicking next, I agree to let Starry contact me about this service.<br class="hidden-mobile">
    I acknowledge my information is subject to and protected under the <a href="https://starry.com/legal/privacy" target="_blank">Starry Privacy Notice</a>.
  </p>
{{else if pii_waitlist}}
  <p class="privacy-text">
    By submitting this form, I agree to let Starry contact me via email about this service.<br class="hidden-mobile">
    I acknowledge my information is subject to and protected under the <a href="https://starry.com/legal/privacy" target="_blank">Starry Privacy Notice</a>.
  </p>
{{else}}
  <p class="privacy-text">
    Your privacy is very important to us. <a href="https://starry.com/legal/privacy" target="_blank">Starry Privacy Notice</a>.
  </p>
{{/if}}
